import React, { useEffect, useRef, useState } from "react";
import { Cor, DadoPesquisaCor, FiltroPesquisaCor } from "app/api/classes/ProdutoApi";
import { useFormik } from "formik";
import { Paginacao } from "app/components/itens-orcamento/paginacao/Paginacao";
const estiloPesquisarCor = require("./pesquisa-cor.module.scss").default;

export type PesquisaCorProps = {
  cores: DadoPesquisaCor;
  filtro: FiltroPesquisaCor;
  tintometricoSimplificado: boolean
  corFundoSelecionado: string;
  corTextoSelecionado: string;
  onPesquisar: (filtro: FiltroPesquisaCor) => void;
  onClickSelecionado: (corSelecionada: Cor) => void;
  onAlterarListaSelecionada: (numeroIndexPagina: number) => void;
};

const PesquisaCor = (props: PesquisaCorProps) => {
  const formik = useFormik({
    initialValues: { ...props.filtro },
    onSubmit: (values, { }) => { },
    enableReinitialize: true,
  });

  const inputCodigoCorFabricanteRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputCodigoCorFabricanteRef.current?.focus();
  }, []);

  const formularioPesquisa = <>
    <form id="form-selecionar-cor">
      <fieldset className={estiloPesquisarCor.separador}
        id="PesquisaCor_fieldset"
      >
        <div className={estiloPesquisarCor.divForm}
          id="PesquisaCor_divForm"
        >
          <label
            id="PesquisaCor_CodCorFabLabel"
          >{props.tintometricoSimplificado ? "Código da Cor" : "Código da Cor do Fabricante"}</label>
          <input
            ref={inputCodigoCorFabricanteRef}
            name="CodigoCorFabricante"
            id="PesquisaCor_CodigoCorFabricante"
            type="text"
            maxLength={254}
            value={formik.values.CodigoCorFabricante ?? ''}
            onChange={formik.handleChange}
          />
        </div>
        <div className={estiloPesquisarCor.divForm}>
          <label
            id="PesquisaCor_DescricaoCorLabel"
          >{props.tintometricoSimplificado ? "Nome da Cor" : "Descrição da Cor"}</label>
          <input
            name="DescricaoCor"
            id="PesquisaCor_DescricaoCor"
            type="text"
            value={formik.values.DescricaoCor ?? ''}
            onChange={formik.handleChange}
          />
        </div>
      </fieldset>
    </form>
    <div>
      <button
        className={estiloPesquisarCor.botao}
        id="PesquisaCor_BotaoPesquisar"
        onClick={() => {
          props.onPesquisar(formik.values);
        }}
      >
        Pesquisar
      </button>
    </div>
  </>

  const tabela = () => {

    const head = <div
      id="PesquisaCor_DivHead"
    >
      <div>{props.tintometricoSimplificado ? "Código da Cor" : "Código da Cor do Fabricante"}</div>
      {!props.tintometricoSimplificado &&  //PA 402355 repasse 311033
        <div>{props.cores?.Legenda}</div>
      }
      <div>{props.tintometricoSimplificado ? "Nome da Cor" : "Descrição da Cor"}</div>
    </div>

    const corpo = props.cores?.CoresProduto?.Entities?.map((cor) => {
      return (
        <div
          key={cor.Codigo}
          id={`PesquisaCor_Corpo_{cor.Codigo}`}
          style={
            cor.Codigo == corSelecionada?.Codigo
              ? {
                backgroundColor: props.corFundoSelecionado,
                color: props.corTextoSelecionado,
              }
              : {}
          }
          className={
            cor.Codigo == corSelecionada?.Codigo
              ? estiloPesquisarCor.linhaSelecionada
              : estiloPesquisarCor.linha
          }
          onClick={() => {
            cor.Codigo == corSelecionada?.Codigo
            setCorSelecionada(cor)
          }}
        >
          <div>{cor.CodigoExterno}</div>
          {!props.tintometricoSimplificado &&  //PA 402355 repasse 311033
            <div>{cor.CodigoExterno2}</div>
          }
          <div
            id={`PesquisaCor_Corpo_{cor.Codigo}`}
          >{cor.Nome}</div>
        </div>
      );
    })

    const paginacao = props.cores?.CoresProduto?.PageCount > 1 && (
      <>
        <br />
        <Paginacao
          paginaAtual={props.cores?.CoresProduto?.ActualPage}
          totalPaginas={props.cores?.CoresProduto?.PageCount}
          onAlterarListaSelecionada={props.onAlterarListaSelecionada}
          id="PesquisaCor_Paginacao"
        />
        <br />
      </>
    )

    const botoes = <div>
      <button
        id="PesquisaCor_botaoOk"
        style={
          corSelecionada != null
            ? { backgroundColor: "#409fff" }
            : { backgroundColor: "var(--mu-superficie-sutil, #f1f2f2)", color: "var(--mu-texto, #000)" }
        }
        onClick={() => {
          props.onClickSelecionado(corSelecionada);
        }}
        className={estiloPesquisarCor.botao}
      >
        OK
      </button>
      <br />
    </div>

    return props.cores?.CoresProduto?.Entities?.length > 0 && (
      <>
        {botoes}
        <div 
          id="tabela-fornecedores" 
          className={estiloPesquisarCor.tabela}
        >
          {head}

          {corpo}
        </div>

        {paginacao}

        {botoes}
      </>
    )
  }

  const [corSelecionada, setCorSelecionada] = useState<Cor>(null)
  return (
    <>
      {formularioPesquisa}

      {tabela()}
      {<section style={{ marginBottom: "100px" }} />}
    </>
  );
};

export { PesquisaCor };
